import * as React from "react";

const Filer: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM3.3332 4H12.6665V5.33333L8.99986 10H6.99986L3.3332 5.33333V4ZM6.99986 10.3333H8.99986V13L6.99986 14V10.3333Z" fill="currentColor"/>
        </svg>     
    );
};

export default React.memo(Filer);
